Ext.define('SA.view.sidebar.SidebarList', {
    alias: 'widget.sidebar-list',
    extend: 'Ext.Component',

    cls: 'sa-sidebar-list',

    tpl: [
        '<tpl for=".">',
            '<button class="sa-sidebar-list-item x-unselectable',
                '<tpl if="disabled"> sa-sidebar-list-item-disabled</tpl>',
                '" data-id="{id:htmlEncode}">',
                '<tpl if="icon">',
                    '<svg aria-hidden="true" class="sa-sidebar-list-item-icon"><use href="#{icon}"></use></svg>',
                '</tpl>',
                '<div class="sa-sidebar-list-item-name">{text:htmlEncode}</div>',
                '<svg aria-hidden="true" class="sa-sidebar-list-item-arrow"><use href="#sa-icon-right-chevron"></use></svg>',
            '</button>',
        '</tpl>'
    ],

    initComponent() {
        this.setItems(this.items || []);

        this.callParent();
    },

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: '.sa-sidebar-list-item',
            scope: this,

            click: this.onItemClick,
            mouseout: this.onItemMouseOut,
            mouseover: this.onItemMouseOver
        });
    },

    getItemById(id) {
        if (id == null || Ext.isObject(id)) {
            return id;
        }

        return this.items.find(item => item.id === id);
    },

    getItemEl(id) {
        id = Ext.isObject(id) ? id.id : id;

        var items = this.el.query('.sa-sidebar-list-item');

        return items.find(dom => dom.getAttribute('data-id') === id);
    },

    getSelected() {
        return this.selected;
    },

    handler() {},

    onItemClick(ev, target) {
        if (Ext.fly(target).hasCls('sa-sidebar-list-item-disabled')) {
            return;
        }

        this.toggleSelected(target.getAttribute('data-id'));
    },

    onItemMouseOut(ev, target) {
        if (Ext.fly(target).hasCls('sa-sidebar-list-item-disabled')) {
            return;
        }

        Ext.fly(target).removeCls('sa-sidebar-list-item-over');
    },

    onItemMouseOver(ev, target) {
        if (Ext.fly(target).hasCls('sa-sidebar-list-item-disabled')) {
            return;
        }

        Ext.fly(target).addCls('sa-sidebar-list-item-over');
    },

    setItems(items) {
        items = this.items = items.map(item => {
            return Object.assign({
                handler: 'handler',
                hidden: false,
                id: Ext.id()
            }, item);
        });

        this.update(items);
    },

    setSelected(item) {
        var id;

        item = this.getItemById(item);

        if (this.selected === item) {
            return;
        }

        this.selected = item;

        id = item && item.id;

        this.el.query('.sa-sidebar-list-item').forEach(dom => {
            var itemId = dom.getAttribute('data-id');

            Ext.fly(dom).ifCls(id === itemId, 'sa-sidebar-list-item-active');
        });

        if (item) {
            Ext.callback(item.handler, item.scope || this.scope || this, [item]);
            this.fireEvent('select', item.id);
        }
        else {
            Ext.callback(this.handler, this.scope || this);
            this.fireEvent('deselect');
        }
    },

    toggleSelected(item) {
        item = this.getItemById(item);

        this.setSelected(this.selected === item ? null : item);
    }
});
